module.exports = __webpack_public_path__ + "static/media/GW-Discrepancy.60f37f45.pdf";